import React from 'react';

const DeviceImage = ({ deviceType }: { deviceType: string }) => {
  switch (deviceType) {
    case 'QUEST2':
      return <img alt={deviceType} title={deviceType} className="device-image"
                  src={require('url:../../static/images/devices/QUEST2.png')}/>
    case 'QUEST3':
      return <img alt={deviceType} title={deviceType} className="device-image"
                  src={require('url:../../static/images/devices/QUEST3.png')}/>
    case 'QUEST3s':
      return <img alt={deviceType} title={deviceType} className="device-image"
                  src={require('url:../../static/images/devices/QUEST3s.png')}/>

    case 'PICO4ULTRA':
      return <img alt={deviceType} title={deviceType} className="device-image"
                  src={require('url:../../static/images/devices/PICO4ULTRA.png')}/>

    case 'PICO4ULTRAENTERPRISE':
      return <img alt={deviceType} title={deviceType} className="device-image"
                  src={require('url:../../static/images/devices/PICO4ULTRAENTERPRISE.png')}/>

    case 'WIN64PC':
      return <img alt={deviceType} title={deviceType} className="device-image"
                  src={require('url:../../static/images/devices/WIN64PC.png')}/>
    default:
      return <></>;
  }
}

export default DeviceImage;